import { z } from 'zod';
const notificationTypeEnum = z.enum(['pipeline', 'issue', 'task', 'system', 'ai_chat']);
export const notificationListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).optional().default(1),
    perPage: z.coerce.number().int().min(1).max(100).optional().default(20),
    type: notificationTypeEnum.optional(),
    read: z.enum(['true', 'false']).transform((v) => v === 'true').optional(),
    level: z.enum(['info', 'success', 'warning', 'error']).optional(),
});
export const notificationIdParamSchema = z.object({
    id: z.coerce.number().int().positive(),
});
export const notificationPreferenceUpdateSchema = z.object({
    category: notificationTypeEnum,
    inApp: z.boolean().optional(),
    desktop: z.boolean().optional(),
    email: z.boolean().optional(),
    sound: z.boolean().optional(),
    digestFrequency: z.enum(['none', 'daily']).optional(),
});
export const pushSubscriptionSchema = z.object({
    endpoint: z.string().url(),
    keys: z.object({
        p256dh: z.string().min(1),
        auth: z.string().min(1),
    }),
});
//# sourceMappingURL=notification.schema.js.map